import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { format } from 'date-fns';

interface AffectedReportProps {
  startDate: string | undefined;
  endDate: string | undefined;
}

export function AffectedReport({ startDate, endDate }: AffectedReportProps) {
  if (!startDate || !endDate) {
    return null;
  }

  return (
    <div className="flex flex__ai--center">
      <Icon name="calendar" size={IconSizeClasses.Small} className="m-right-s" />
      {format(startDate, 'dd MMM yyyy')} - {format(endDate, 'dd MMM yyyy')}
    </div>
  );
}
